import { Pipe, PipeTransform } from '@angular/core';
/*
 * Given a key, return the respective icon class
 * Takes an string argument.
 * Usage:
 *   key | icon
 * Example:
 *   {{ 'Online' | icon }}
 *   return: 'online-icon'
 */
@Pipe({ name: 'icon' })
export class IconsPipe implements PipeTransform {
  transform(key: string): string {
    const mappingIcons = {
      // Types
      Online: 'online-icon',
      Offline: 'offline-icon',
      Batch: 'batch-icon',

      // Branch
      Autos: 'fa-car',
      Motos: 'fa-motorcycle',
      'Television por cable': 'fa-television',
      'Subscripcion periodico': 'fa-newspaper-o',
      'Compra protegida': 'fa-shopping-cart',
      'Bolso protegido': 'fa-shopping-bag',
      'Asistencia hogar': 'fa-home',
      'Accidentes personales': 'acc-pers-icon',
      'Robo en cajero': 'robo-cajero-icon',
      'Asistencia vehiculo': 'asist-vehiculo-icon',

      // Countries
      Argentina: 'flag-icon-ar',
      Mexico: 'flag-icon-mx',

      ARG: 'flag-icon-ar',
      BRA: 'flag-icon-br',
      GBR: 'flag-icon-gb',

      Opcion: 'fa fa-list',
      Assets: 'fa fa-folder-open',
      Formulario: 'fa fa-code',
      Template: 'fa fa-file-text',
      XmlTemplate: 'fa fa-file-text',
      Regla: 'fa fa-file-text',
      FormularioDinamico: 'fa fa-object-group',
      Solicitud: 'fa fa-ticket',
      Settings: 'fa fa-cog',
      Sponsor: 'fa fa-paint-brush',

      Contenido: 'fa fa-desktop',
      Cotización: 'fa fa-tasks',
      Oportunidad: 'fa fa-plus-square',
      Venta: 'fa fa-usd',
      Endosos: 'fa fa-files-o',
      'Numerador Pólizas': 'fa fa-files-o',
      Opciones: 'fa fa-gears',
      Usuarios: 'fa fa-users',
      UserCircle: 'fa fa-user-circle-o',

      'Consultas Cartera': 'fa fa-briefcase',
      Configuracion: 'fa fa-cogs',
      UserPolicies: 'fa fa-sitemap',
      usersAdmin: 'fa fa-user-plus',
      profilesAdmin: 'fa fa-angle-double-right',
      userProfilesAdmin: 'fa fa-user',
      ProductCategories: 'fa fa-tag',
      List: 'fa fa-list',
      PRODUCTFLOW: 'fa fa-tasks',
      Upload: 'fa fa-upload',
      PaymentGateway: 'fa fa-money',
      ProductReport: 'fa fa-briefcase',
      ExternalComponent: 'fa fa-sitemap',
      Currency: 'fab fa-bitcoin',

      CONS: 'fa fa-briefcase',
      USU: 'fa fa-users',
      OPC: 'fa fa-gears',
      InbrokerProvider: 'fa fa-plug',
      ExcelProvider: 'fa fa-plug',
      PF: 'fa fa-gears',
      END: 'fa fa-files-o',
      NUMPOL: 'fa fa-list-ol',
      CONT: 'fa fa-folder-open',
      COT: 'fa fa-tasks',
      OPORT: 'fa fa-plus-square',
      VTA: 'fa fa-usd',
      OUTPUT: 'fa fa-files-o',

      //for customers

      CustomerSyncronization: 'fa fa-folder-open',
      CustomerSave: 'fa fa-files-o',
      CustomerList: 'fa fa-list',
      CF: 'fa fa-gears',

      //Designer Icons
      Int32: 'icon-fa-number',
      Email: 'fa fa-envelope-open',
      TABLA: 'fa fa-table',
      DateTime: 'fa fa-calendar',
      DateTimeISO: 'fas fa-calendar-alt',
      Boolean: 'icon-fa-boolean',
      String: 'fa fa-font',
      LIST: 'fa fa-list',
      Decimal: 'fa fa-hashtag',
      TABLA_SIMPLE: 'fa fa-table',
      '': 'fa fa-code',
      null: 'fa fa-code'
    };

    return mappingIcons[key] || '';
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/helpers/pipes/icons.pipe.ts